/**
 * The query builder's state, per tab only (spec §15.10, Q95): `sessionStorage`, with the SPARQL it
 * generated. Never in Loro or on the server, so other readers, other tabs and a closed browser never
 * see it. It is valid only while the editor still holds exactly that SPARQL: a hand edit detaches it.
 */
const PREFIX = "kss.builder:";

interface Saved {
  json: unknown;
  sparql: string;
}

function storage(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null; // a private window or blocked storage: the builder simply opens empty
  }
}

export function writeBuilderState(key: string, json: unknown, sparql: string): void {
  try {
    storage()?.setItem(PREFIX + key, JSON.stringify({ json, sparql } satisfies Saved));
  } catch {
    // quota or serialisation: nothing to keep
  }
}

export function readBuilderState(key: string): Saved | null {
  try {
    const raw = storage()?.getItem(PREFIX + key);
    return raw ? (JSON.parse(raw) as Saved) : null;
  } catch {
    return null;
  }
}

/** Drop the state when the editor's query is no longer the one the builder generated. */
export function reconcileBuilderState(key: string, currentQuery: string): void {
  const saved = readBuilderState(key);
  if (saved && saved.sparql.trim() !== currentQuery.trim()) {
    try {
      storage()?.removeItem(PREFIX + key);
    } catch {
      // nothing to drop
    }
  }
}
